<template>
  <div
    class="modal_wrapper"
    @click.stop="closeModal()"
  >
    <div
      class="modal_window white_box create_report_modal"
      @click.stop=""
    >
      <div class="heading_wrapper">
        <h3 class="heading">
          Bulk Add Keywords
        </h3>
        <button
          class="close_modal close_btn"
          @click="closeModal()"
        >
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 7L7 25"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M25 25L7 7"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </button>
      </div>

      <p class="xs-mb-0 xs-pb-0">
        <strong>Enter Keywords</strong> (one per line) - these keywords will be automatically
        added to your basket
      </p>
      <textarea
        v-model="bulkKeywords"
        class="bulkKeywordsText"
        cols="30"
        name="keywords"
        rows="8"
      />
      <div class="modal-alert-holder" />
      <small class="text-danger">*Suggestions will not be shown for keywords added in bulk</small>

      <div class="footer">
        <button
          :disabled="loading"
          class="btn secondary_btn btn_md"
          type="button"
          @click="closeModal()"
        >
          Close
        </button>
        <button
          :disabled="loading"
          class="btn primary_btn btn_md"
          type="button"
          @click="addKeywords()"
        >
          <i
            v-if="loading"
            class="fas fa-spinner fa-spin"
          />
          {{ loading ? 'Adding Keywords' : 'Add Keywords' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      bulkKeywords: '',
      loading: false,
    }
  },
  computed: {
    ...mapGetters('keywordIdeas', [
      'keywordLimit',
      'chosenKeywords',
      'newChosenKeywords',
      'removeChosenKeywords'
    ]),
  },
  mounted() {
    this.bulkKeywords = this.bulkAddPrefill;
  },
  methods: {
    ...mapActions('keywordIdeas', [
        'bulkAddKeywordSuggestions',
        'closeBulkAddModal'
    ]),
    addKeywords() {
      this.loading = true;
      this.bulkAddKeywordSuggestions({
        keywords: this.bulkKeywords,
        chosenKeywords: this.chosenKeywords,
        newChosenKeywords: this.newChosenKeywords,
      })
        .then(() => {
          this.loading = false;
          this.bulkKeywords = '';
          this.closeModal();
        })
        .catch(({ data }) => {
          const {message, error} = data;
          Swal.fire({
            title: message ?? `Something went wrong`,
            icon: 'warning',
            html: error ?? '',
            confirmButtonText: 'Ok',
            backdrop: true,
          })
          this.loading = false;
        });
    },
    closeModal() {
      this.closeBulkAddModal();
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  padding: 5vh 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal_wrapper::-webkit-scrollbar {
  width: 0;
}

.modal_window {
  z-index: 101;
  position: relative;
  margin: auto;
  max-width: 900px;
  width: 90vw;
  -webkit-box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  border-radius: .75rem;
}

.close_btn {
  height: auto;
}

.heading_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.heading {
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
}

.bulkKeywordsText {
  width: 100%;
  background-color: #fff;
  border: 1px solid #E8E5E2;
  padding: 1rem;
  border-radius: 12px;
  font-size: 0.875rem;
  line-height: 1.72;
  letter-spacing: -0.00715em;
  color: #4E4E54;
}

.footer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.footer .btn {
  height: 42px;
  padding-top: 0;
  padding-bottom: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
}

.footer i {
  margin-right: 5px;
}
</style>
